import { ReactNode } from 'react'
import SectionContainer from './SectionContainer'

interface Props {
  children: ReactNode
  className?: string
  wrapContent?: boolean
}

/**
 * FullBleedSection - A component for creating edge-to-edge sections that break out of container constraints
 *
 * @param {ReactNode} children - The content to display
 * @param {string} className - Additional CSS classes to apply to the container
 * @param {boolean} wrapContent - Whether to wrap the content in a constrained SectionContainer
 */
export default function FullBleedSection({ children, className = '', wrapContent = true }: Props) {
  return (
    <div
      className={`relative right-[50%] left-[50%] -mr-[50vw] -ml-[50vw] w-screen px-4 md:px-0 ${className}`}
    >
      {wrapContent ? <SectionContainer>{children}</SectionContainer> : children}
    </div>
  )
}
